import { OpenAPI } from './api';
import { useAuthStore } from '@/stores/authStore';

// Configure the OpenAPI client
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8081';
OpenAPI.BASE = API_BASE_URL;

// Configure request interceptor for authentication
OpenAPI.TOKEN = async () => {
  // Get token from auth store first, fallback to localStorage
  // Check both 'access_token' and 'token' keys for compatibility
  const storeToken = useAuthStore.getState().token;
  const accessToken = localStorage.getItem('access_token');
  const localToken = localStorage.getItem('token');
  const token = storeToken || accessToken || localToken || '';
  await Promise.resolve();
  return token;
};

// Configure response interceptor for error handling
OpenAPI.WITH_CREDENTIALS = false;

// Export configured API services
export * from './api';
